import React from 'react';

export const EMPTY_SCAN_LOGIN = {
  method: 'browser', login_url: '', username: '', password: '', logged_in_url: '', logged_in_text: '',
  header_name: 'Authorization', header_value: '',
};

export function scanLoginFieldsError(form, { savedPassword = false, savedValue = false } = {}) {
  if (form.method === 'browser') {
    return (!form.login_url.trim() && 'Enter the login page URL.')
      || (!form.username.trim() && 'Enter the username.')
      || (!savedPassword && !form.password && 'Enter the password.')
      || (!form.logged_in_url.trim() && 'Enter a page only logged-in users can open.')
      || (!form.logged_in_text.trim() && 'Enter text that page shows only when logged in.')
      || '';
  }
  return (!form.header_name.trim() && 'Enter the header name, for example Authorization or Cookie.')
    || (!savedValue && !form.header_value && 'Enter the header value.')
    || '';
}

export function scanLoginPayload(form) {
  return form.method === 'browser' ? {
    method: 'browser', login_url: form.login_url.trim(), username: form.username.trim(), password: form.password,
    logged_in_url: form.logged_in_url.trim(), logged_in_text: form.logged_in_text.trim(),
  } : { method: 'header', header_name: form.header_name.trim(), header_value: form.header_value };
}

/** The details of a scan login; shared by Settings and the web scan form. */
export default function ScanLoginFields({ value, onChange, disabled, idPrefix = 'scan-network-login', savedPassword = false, savedValue = false }) {
  const id = (name) => `${idPrefix}-${name}`;
  return (
    <>
      <label className="scan-network-field" htmlFor={id('method')}>
        <span>How the scan logs in</span>
        <select id={id('method')} className="scan-network-select" value={value.method} disabled={disabled}
          onChange={(e) => onChange({ method: e.target.value })}>
          <option value="browser">Login page (username and password)</option>
          <option value="header">Fixed header or token</option>
        </select>
      </label>
      {value.method === 'browser' ? (
        <>
          <label className="scan-network-field" htmlFor={id('url')}>
            <span>Login page URL</span>
            <input id={id('url')} className="scan-network-input" type="url" value={value.login_url} disabled={disabled}
              placeholder="https://www.example.com/login" onChange={(e) => onChange({ login_url: e.target.value })} />
          </label>
          <label className="scan-network-field" htmlFor={id('username')}>
            <span>Username</span>
            <input id={id('username')} className="scan-network-input" autoComplete="off" value={value.username} disabled={disabled}
              onChange={(e) => onChange({ username: e.target.value })} />
          </label>
          <label className="scan-network-field" htmlFor={id('password')}>
            <span>Password</span>
            <input id={id('password')} className="scan-network-input" type="password" autoComplete="new-password"
              value={value.password} disabled={disabled} placeholder={savedPassword ? 'Saved (leave blank to keep it)' : ''}
              onChange={(e) => onChange({ password: e.target.value })} />
          </label>
          <label className="scan-network-field" htmlFor={id('page')}>
            <span>A page only logged-in users can open</span>
            <input id={id('page')} className="scan-network-input" type="url" value={value.logged_in_url} disabled={disabled}
              placeholder="https://www.example.com/account" onChange={(e) => onChange({ logged_in_url: e.target.value })} />
          </label>
          <label className="scan-network-field" htmlFor={id('text')}>
            <span>Text that page shows when logged in</span>
            <input id={id('text')} className="scan-network-input" value={value.logged_in_text} disabled={disabled}
              placeholder="Sign out" onChange={(e) => onChange({ logged_in_text: e.target.value })} />
          </label>
        </>
      ) : (
        <>
          <label className="scan-network-field" htmlFor={id('header')}>
            <span>Header name</span>
            <input id={id('header')} className="scan-network-input" value={value.header_name} disabled={disabled}
              onChange={(e) => onChange({ header_name: e.target.value })} />
          </label>
          <label className="scan-network-field" htmlFor={id('value')}>
            <span>Header value</span>
            <input id={id('value')} className="scan-network-input" type="password" autoComplete="off"
              value={value.header_value} disabled={disabled}
              placeholder={savedValue ? 'Saved (leave blank to keep it)' : 'Bearer eyJ… or session=…'}
              onChange={(e) => onChange({ header_value: e.target.value })} />
          </label>
        </>
      )}
    </>
  );
}
